import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { AlertCircle } from '../../../components/Icon';

const NotificationIconWrapper = styled.div`
  a {
    position: relative;
  }

  .icon-wrapper {
    font-size: 20px;
    color: ${props => (props.iconColor == 'grey' ? '#ccc' : 'red')};
  }

  .alert-alt-block {
    position: absolute;
    top: ${props => (props.top ? props.top : '100%')};
    right: ${props => (props.right ? props.right : '100%')};
    left: ${props => props.left && props.left};
    z-index: 99999999999999;
    min-width: ${props => (props.minWidth ? props.minWidth : '500px')};
    max-width: 1100px;
    padding: 4px 8px;
    background-color: #ccc;
    color: black;
    white-space: pre-wrap; /* or pre-line */
    text-align: left;
    border-radius: 5px;
    text-transform: none !important;
  }

  .alert-alt-block .p {
    color: black;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class OnMouseOverNotificationComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  isHovered(hoveredOption, vehicleId) {
    this.setState({ isHover: hoveredOption, hoveredId: vehicleId });
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    const { minWidth, top, right, left, iconColor } = this.props;
    return (
      <NotificationIconWrapper minWidth={minWidth} top={top} right={right} left={left} iconColor={iconColor}>
        <a onMouseEnter={() => this.isHovered(true)} onMouseLeave={() => this.isHovered(false)}>
          <div className="icon-wrapper">
            <AlertCircle />
          </div>
          {this.state.isHover && <div className="alert-alt-block">{this.props.message}</div>}
        </a>
      </NotificationIconWrapper>
    );
  }
}

OnMouseOverNotificationComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OnMouseOverNotification = compose(withConnect, withRouter, injectIntl)(OnMouseOverNotificationComp);
